import {
    Box,
    ThemeProvider,
    Toolbar
} from "@mui/material";

import { PublicPropertyDashboardMainBar } from "../property/PublicPropertyDashboardMainBar";
import { SolutionDashboard } from "../../components/solution/dashboard/SolutionDashboard";
import { theme } from "../../assets/style/dashboardTheme";

export const PublicSolutionDashboardPage = () => {
    return (
        <ThemeProvider theme={theme}>
            <PublicPropertyDashboardMainBar />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    overflow: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    pt: 6
                }}
            />
            <Toolbar />
            <SolutionDashboard />
        </ThemeProvider>
    );
};